export const locales = ['fr', 'en'];
